import React, { useState, useEffect } from 'react';
import { Button, Card, CardContent, Grid } from '@mui/material';
import { CustomButton } from '../../common/custom-button/customButton';
import { Box, Stack } from '@mui/system';
import { FinancialYearDropdown } from './FinancialYearDropdown';
import { GET_APPROVED_STAKEHOLDERS, GET_LLE_CHIPPING_CAPACITY, UPDATE_LLE_CHIPPING_CAPACITY } from '../../common/URLs';
import { loaderService } from '../../common/custom-loader/loader-service';
import { toast } from 'react-toastify';
import { userData } from '../../common/spinLoader';
import { DataGrid, GridEditInputCell, GridToolbarQuickFilter, useGridApiContext } from '@mui/x-data-grid';
import DownloadIcon from '@mui/icons-material/Download';
import * as XLSX from 'xlsx';
import AddIcon from '@mui/icons-material/Add';
import { DEMAND_CONSTANTS, DEMAND_ROLES, PROD } from '../../common/constants';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { styled } from '@mui/material/styles';
import { DEMAND_VALIDATIONS } from '../../common/commonValidations';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { useTranslation } from 'react-i18next';
import CustomDataGridToolbarServer from '../../common/customDataGridToolbarServer';
import { SaveIcon } from '../../common/icons';
import apiClient from '../../axios';

export const LleChippingCapacity = () => {
    const { t } = useTranslation();
    const uuid = localStorage.getItem('uuid');
    const userLoggedIn = userData?.user?.userRoles?.[0].roleName
    const [selectedFinancialYear, setSelectedFinancialYear] = useState();
    const [combinedFinalMbrData, setCombinedFinalMbrData] = useState([]);
    const [getStakeholderByTypeApiData, setGetStakeholderByTypeApiData] = useState([]);
    const [lleData, setLleData] = React.useState([]);
    const [isAddDisabled, setIsAddDisabled] = React.useState(true);
    const [isSaveDisabled, setIsSaveDisabled] = React.useState(true);
    const [showAddLleBtn, setShowAddLleBtn] = React.useState(true);
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(5);
    const [rowCount, setRowCount] = React.useState(0);
    const [sortField, setSortField] = React.useState(null);
    const [sortOrder, setSortOrder] = React.useState(null);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [saveChippingCapacityDialog, setSaveChippingCapacityDialog] = useState(false);
    const handleSaveChippingCapacityDialogOpen = () => setSaveChippingCapacityDialog(true);
    const handleSaveChippingCapacityDialogClose = () => setSaveChippingCapacityDialog(false);



    const StyledTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
        },
    }));

    function EditInputCell(props) {
        const { error, id, value: valueProp, field } = props;
        const [value, setValue] = useState(valueProp);
        const apiRef = useGridApiContext();

        const handleChange = (event) => {
            const newValue = event.target.value; 
            apiRef.current.setEditCellValue({ id, field, value: newValue });
            setValue(newValue);
        };

        useEffect(() => {
            setValue(valueProp);
        }, [valueProp]);

        return (
            <StyledTooltip open={!!error} title={error}>
                <GridEditInputCell {...props} value={value} onChange={handleChange} />
           </StyledTooltip>
        );
    }

    function renderEdit(params) {
        return <EditInputCell {...params} />;
    }

    const columns = [
        { field: 'stakeholderURN', headerName: 'URN', width: 150 },
        { field: 'stakeholderType', headerName: 'Type' },
        { field: 'name', headerName: t('preReg.name'), width: 200 },
        { field: 'state', headerName: 'State', width: 210 },
        { field: 'district', headerName: 'District', width: 210 },
        {
            field: 'chippingCapacity', headerName: 'Daily Chipping Capacity(in MT)', width: 250, type: 'number', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner),
            preProcessEditCellProps: (params) => {
                return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
            },
            renderEditCell: renderEdit,
        },
    ];

    const getSelectedValue = (dataToBePassed) => {
        setSelectedFinancialYear(dataToBePassed);
        getStakeholderByTypeApi(dataToBePassed);
        setIsAddDisabled(false);
        setIsSaveDisabled(false);
        setShowAddLleBtn(true);
    }

    const CustomToolbar = () => {
        const exportToExcel = (data) => {
            const ws = XLSX.utils.json_to_sheet(combinedFinalMbrData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Data");
            XLSX.writeFile(wb, "ChippingCapacity.xlsx");
        };

        return (
            <>
                <Box
                    sx={{ p: 0.5, pb: 0, float: 'right' }}>
                    <GridToolbarQuickFilter />
                </Box>
                <Box
                    sx={{ p: 0.5, pb: 0, float: 'left' }}>
                    <Button startIcon={<DownloadIcon />} onClick={() => exportToExcel(combinedFinalMbrData)}>Download</Button>

                </Box>
            </>

        );
    }

    const addLLEBtnApi = () => {
        let res = [];
        const temp = getStakeholderByTypeApiData === null || getStakeholderByTypeApiData?.length === 0 ? toast.info(DEMAND_CONSTANTS.NoDataMessage) :
            getStakeholderByTypeApiData?.map((data) => {
                let tempData = { ...data }
                tempData.chippingCapacity = 0
                return {
                    'stakeholderURN': tempData.urn,
                    'chippingCapacity': tempData.chippingCapacity,
                    'stakeholderType': 'LLE',
                    'name': tempData.name,
                    'district': tempData.district,
                    'state': tempData.state
                }
            })
        res = temp?.filter(el => {
            return !lleData?.find(element => {
                return element.stakeholderURN === el.stakeholderURN;
            });
        });
        let finalData = [...res, ...lleData]
        setLleData(finalData);
        setShowAddLleBtn(false);
    }

    const processRowUpdate = (newRow) => {
        lleData.forEach((item) => {
            if (item.stakeholderURN === newRow.stakeholderURN) {
                item.chippingCapacity = newRow.chippingCapacity
                item.type = "new"
            }
        })
        return newRow
    }

    // -----------------API Calls-------------------

    const getStakeholderByTypeApi = async (year) => {
        loaderService.showLoader();
        await apiClient.post(GET_APPROVED_STAKEHOLDERS,
            {
                type: 'LLE'
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                const temp = response.data?.stakeHolders;
                setGetStakeholderByTypeApiData(temp);
                getLLEChippingCapacity(year, temp, 'firstCall');
                loaderService.hideLoader();
            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getLLEChippingCapacity = (year, response2, type, newPage, searchInput, isExport, sortByField, sortOrder) => {
        loaderService.showLoader();
        return apiClient.post(GET_LLE_CHIPPING_CAPACITY + `?userId=${uuid}`,
            {
                "financialYear": year,
                "pageNumber": isExport ? null : newPage ? newPage : page,
                "pageSize": isExport ? null : pageSize,
                "searchTerm": searchInput ? searchInput : "",
                "sortBy": sortByField ? sortByField : null,
                "isSortDescending": sortOrder ? (sortOrder == "desc" ? true : false) : null
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                loaderService.hideLoader();
                let response1 = response?.data?.chippingCapacityLst;
                if (isExport) {
                    const result = response1.map((data1) => {
                        const matchingData2 = response2?.find((data2) => {
                            const data1Id = data1.stakeholderUrn;
                            const data2Id = data2.urn;
                            return data2Id === data1Id
                        });
                        return Object.assign({}, data1, matchingData2);
                    })
                    let finalData = result?.map((item) => {
                        return {
                            'stakeholderURN': item.stakeholderUrn,
                            'chippingCapacity': item.chippingCapacity,
                            'stakeholderType': 'LLE',
                            'name': item.name,
                            'district': item.district,
                            'state': item.state
                        }
                    })
                    return finalData
                }
                setRowCount(response?.data?.rowCount)
                if (type === 'firstCall') {
                    const result = response1.map((data1) => {
                        const matchingData2 = response2?.find((data2) => {
                            const data1Id = data1.stakeholderUrn;
                            const data2Id = data2.urn;
                            return data2Id === data1Id
                        });
                        return Object.assign({}, data1, matchingData2);
                    })
                    let finalData = result?.map((item) => {
                        return {
                            'stakeholderURN': item.stakeholderUrn,
                            'chippingCapacity': item.chippingCapacity,
                            'stakeholderType': 'LLE',
                            'name': item.name,
                            'district': item.district,
                            'state': item.state
                        }
                    })
                    setLleData(finalData);
                } else if (type === 'afterUpdateCall') {
                    let finalData = response1?.map((item) => {
                        return {
                            'stakeholderURN': item.stakeholderUrn,
                            'chippingCapacity': item.chippingCapacity,
                            'stakeholderType': 'LLE',
                            'name': item.name,
                            'district': item.district,
                            'state': item.state
                        }
                    })
                    setLleData(finalData);
                };
            }).catch(function (error) {
                toast.error(error.message)
                loaderService.hideLoader();
            });
    }

    const onConfirmSaveChippingCapacity = () => {
        handleSaveChippingCapacityDialogClose();
        loaderService.showLoader();
        apiClient.post(UPDATE_LLE_CHIPPING_CAPACITY + `?userId=${uuid}`,
            {
                "financialYear": selectedFinancialYear,
                "lleLst": lleData.filter((item) => item.type === "new").map((({ type, ...rest }) => rest))
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                toast.success(response.data.message)
                getLLEChippingCapacity(selectedFinancialYear, [], 'afterUpdateCall');
                setShowAddLleBtn(true);
                loaderService.hideLoader();
            }).catch(function (error) {
                toast.error(error.message)
                loaderService.hideLoader();
            });
    }

    const updateLLEChippingCapacity = () => {
        handleSaveChippingCapacityDialogOpen();
    }

    const handleSortModelChange = (model) => {
        setSortField(model[0]?.field);
        setSortOrder(model[0]?.sort);
        getLLEChippingCapacity(selectedFinancialYear, getStakeholderByTypeApiData, "firstCall", null, searchTerm, null, model[0]?.field, model[0]?.sort)
    }

    const fetchData = () => {
        return getLLEChippingCapacity(selectedFinancialYear, getStakeholderByTypeApiData, "firstCall", null, null, true)
    }

    const fetchSearchData = (searchInput) => {
        setSearchTerm(searchInput);
        getLLEChippingCapacity(selectedFinancialYear, getStakeholderByTypeApiData, "firstCall", null, searchInput, null, sortField, sortOrder)
    };

    return (
        <Grid container spacing={1}>
            <Grid item xs={12} lg={12}>
                {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>DEM07</p>}
                <Card style={{ marginBottom: 10 }}>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item xs={12} lg={2}>
                                <FinancialYearDropdown selectedValue={getSelectedValue} />
                            </Grid>
                            {userLoggedIn === DEMAND_ROLES.DemandPlanner &&
                                <Grid item xs={12} lg={10} >
                                    <Stack direction="row" spacing={1} style={{ float: 'right' }}>
                                        <CustomButton startIcon={<SaveIcon />} title="Save Chipping Capacity" disabled={isSaveDisabled} onClick={() => updateLLEChippingCapacity()} />
                                        {showAddLleBtn && <Button variant="contained" startIcon={<AddIcon />} disabled={isAddDisabled} onClick={() => addLLEBtnApi()}>Add LLE</Button>}
                                    </Stack>
                                </Grid>}
                        </Grid>
                    </CardContent>
                </Card>
                <Card>
                    <CardContent>
                        <Box sx={{
                            height: '300', width: '100%', display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            '& .super-app-theme--header': {
                                wordWrap: 'break-word',
                                wordBreak: 'break-all',
                                whiteSpace: 'initial',
                            },
                            '& .MuiDataGrid-cell--editable': {
                                bgcolor: (theme) =>
                                    theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                            },
                            '& .Mui-error': {
                                backgroundColor: `rgb(126,10,15,0.1)`,
                                color: (theme) => theme.palette.error.main,
                            },
                        }}>

                            <Box sx={{ height: 400, width: '100%' }}>
                                <DataGrid
                                    // autoHeight
                                    columns={columns}
                                    getRowId={(row) => row.stakeholderURN}
                                    rows={lleData}
                                    processRowUpdate={processRowUpdate}
                                    components={{ Toolbar: CustomDataGridToolbarServer }}
                                    componentsProps={{ toolbar: { columns: columns, onSearch: fetchSearchData, onFetchData: fetchData, fileName: "LLEChipping.xlsx" } }}
                                    experimentalFeatures={{ newEditingApi: true }}
                                    rowCount={rowCount}
                                    rowsPerPageOptions={[5, 10]}
                                    paginationMode="server"
                                    page={page}
                                    pageSize={pageSize}
                                    onPageChange={(newPage) => { setPage(newPage); getLLEChippingCapacity(selectedFinancialYear, getStakeholderByTypeApiData, "firstCall", newPage, searchTerm, null, sortField, sortOrder) }}
                                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                    sortingMode="server"
                                    onSortModelChange={handleSortModelChange}
                                />
                            </Box>

                        </Box>
                    </CardContent>
                </Card>
            </Grid>
            <ConfirmationPopover onOpen={saveChippingCapacityDialog} onConfirm={onConfirmSaveChippingCapacity} onClose={handleSaveChippingCapacityDialogClose} action="Save Chipping Capacity" />
        </Grid>
    );
}
